import React, { useState } from 'react';
import { Navbar, Dropdown } from 'react-bootstrap';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import { Link } from 'react-router-dom';
import image from '../assets/library-logo-header-LibGuides-2020.png';
import '../App.css';

const Header = () => {
  const [, setLoading] = useState(false);

  const syncGatecount = async () => {
    setLoading(true);

    const loadingToast = toast.info("Syncing...", {
      position: "top-right",
      autoClose: false,
    });

    try {
      const result = await axios.post(process.env.REACT_APP_GATECOUNT_URL, {});
      console.log(result);
      toast.update(loadingToast, {
        render: "Sync Successful",
        type: "success",
        autoClose: 3000,
      });
    } catch (error) {
      toast.update(loadingToast, {
        render: "Sync Failed. Please try again.",
        type: "error",
        autoClose: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Navbar bg="dark" variant="dark" expand="lg" className="w-100">
      <a href="https://library.pfw.edu/" target="_blank" rel="noreferrer">
        <img
          src={image}
          alt="library logo" />
      </a>

      <Navbar.Brand as={Link} to="/collections-data" className="mx-auto">
        <h2>Helmke Library Statistics</h2>
      </Navbar.Brand>

      <div className="icon-group">
        <Dropdown align="end" className="icon-group">
          <Dropdown.Toggle as="div" className="hamburger-toggle">
            <div className="hamburger-lines"></div>
            <div className="hamburger-lines"></div>
            <div className="hamburger-lines"></div>
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item as={Link} to="/collections-data">Collections Data</Dropdown.Item>
            <Dropdown.Item as={Link} to="/lab-data">Digital Arts and Humanities Lab Data</Dropdown.Item>
            <Dropdown.Item as={Link} to="/group-study-rooms">Group Study Rooms Data</Dropdown.Item>
            <Dropdown.Item as={Link} to="/transaction-data">Transactions Statistics</Dropdown.Item>
            <Dropdown.Item as={Link} to="/laptop-statistics">Laptops Statistics</Dropdown.Item>
            <Dropdown.Item onClick={syncGatecount}>Sync Gatecount</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
      <ToastContainer />
    </Navbar>
  );
};

export default Header;
